import { Icon20LockOutline } from '@vkontakte/icons';
import emptyVigboFinishedBottomDark from 'img/empty-state/empty_vigbo_finished_bottom_dark.png';
import emptyVigboFinishedBottomLight from 'img/empty-state/empty_vigbo_finished_bottom_light.png';
import emptyVigboFinishedTop from 'img/empty-state/empty_vigbo_finished_top.png';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { vigboTariffs } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { getLatestExpiredSubscription } from 'reactApp/modules/billingData/billingData.helpers';
import { PastSubscriptionsSelectors } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.selectors';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { getVigboProductIdByTrial } from 'reactApp/modules/vigbo/vigbo.helpers';
import type { RootState } from 'reactApp/store';
import { Button } from 'reactApp/ui/Button/Button';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './EmptyFinishedVigbo.css';

export function EmptyFinishedVigbo() {
    const dispatch = useDispatch();

    useEffect(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'show-promo-buy',
        });
    }, []);

    const vigboFinishedSubs = useSelector((state: RootState) =>
        PastSubscriptionsSelectors.getPastSubscriptionsByProductIds(state, vigboTariffs)
    );
    const latestFinishedTariff = useMemo(() => getLatestExpiredSubscription(vigboFinishedSubs), [vigboFinishedSubs]);

    const onClick = useCallback(() => {
        if (!latestFinishedTariff) {
            return;
        }

        const productId = latestFinishedTariff.isTrial ? getVigboProductIdByTrial(latestFinishedTariff) : latestFinishedTariff.productId;
        if (productId) {
            productsController.updateProducts(productId).then((product) => {
                if (!product || !product.available) {
                    return;
                }

                dispatch(
                    openTariffBuy({
                        productId: product.id,
                        paySource: getPaySource('vigbo-end-tariff-empty'),
                    })
                );
            });
        }

        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'click-promo-buy',
        });
    }, [latestFinishedTariff]);

    const isDarkTheme = useSelector(isCurrentDarkTheme);

    return (
        <div className={styles.root}>
            <div className={styles.lockIcon}>
                <Icon20LockOutline />
            </div>
            <img className={styles.topImage} src={emptyVigboFinishedTop} alt="Vigbo picture" />
            <div className={styles.content}>
                <div className={styles.text}>
                    <div className={styles.header}>Тут будут галереи Vigbo</div>
                    <div className={styles.description}>
                        Подключите подписку для фотографов Mail Space и Vigbo, чтобы этот раздел снова стал доступен
                    </div>
                </div>
                <Button className={styles.button} onClick={onClick} theme="vk" primary>
                    Вернуть со скидкой
                </Button>
            </div>
            <img
                className={styles.bottomImage}
                src={isDarkTheme ? emptyVigboFinishedBottomDark : emptyVigboFinishedBottomLight}
                alt="Albums picture"
            />
        </div>
    );
}
